import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressCard = ({ progress, merchant }) => {
  const getStatusColor = (status) => {
    const colors = {
      active: 'text-success',
      pending: 'text-warning',
      suspended: 'text-error',
      inactive: 'text-muted-foreground'
    };
    return colors?.[status] || colors?.pending;
  };

  const getProgressColor = () => {
    if (progress >= 100) return 'bg-success';
    if (progress >= 50) return 'bg-warning';
    return 'bg-primary';
  };

  return (
    <div className="bg-card border border-border rounded-xl p-6 shadow-sm">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Onboarding Progress</h3>
          <p className="text-sm text-muted-foreground">Track merchant activation journey</p>
        </div>
        <div className={`px-3 py-1 rounded-full text-sm font-medium capitalize ${getStatusColor(merchant?.status)}`}>
          {merchant?.status}
        </div>
      </div>

      {/* Progress Bar */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Completion</span>
          <span className="text-2xl font-bold text-foreground">{progress}%</span>
        </div>
        <div className="w-full bg-muted rounded-full h-3">
          <div
            className={`h-3 rounded-full transition-all ${getProgressColor()}`}
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-3 gap-4 mt-6 pt-6 border-t border-border">
        <div className="text-center">
          <div className="p-2 rounded-lg bg-primary/10 w-fit mx-auto mb-2">
            <Icon name="Calendar" size={20} className="text-primary" />
          </div>
          <p className="text-xs text-muted-foreground mb-1">Registered</p>
          <p className="text-sm font-semibold text-foreground">
            {merchant?.registrationDate ? new Date(merchant?.registrationDate)?.toLocaleDateString('id-ID', { day: '2-digit', month: 'short' }) : '-'}
          </p>
        </div>
        <div className="text-center">
          <div className="p-2 rounded-lg bg-success/10 w-fit mx-auto mb-2">
            <Icon name="CheckCircle" size={20} className="text-success" />
          </div>
          <p className="text-xs text-muted-foreground mb-1">Activated</p>
          <p className="text-sm font-semibold text-foreground">
            {merchant?.activationDate ? new Date(merchant?.activationDate)?.toLocaleDateString('id-ID', { day: '2-digit', month: 'short' }) : '-'}
          </p>
        </div>
        <div className="text-center">
          <div className="p-2 rounded-lg bg-warning/10 w-fit mx-auto mb-2">
            <Icon name="Clock" size={20} className="text-warning" />
          </div>
          <p className="text-xs text-muted-foreground mb-1">Duration</p>
          <p className="text-sm font-semibold text-foreground">
            {merchant?.registrationDate && merchant?.activationDate
              ? `${Math.ceil((new Date(merchant?.activationDate) - new Date(merchant?.registrationDate)) / (1000 * 60 * 60 * 24))} days`
              : '-'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProgressCard;